import { createApp } from 'vue'
import CheckoutStepTwo from './CheckoutStepTwo'

const el = '.kb-component--checkout-step-two'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((CheckoutStepTwoDOM) => {
            const addressResults = CheckoutStepTwoDOM.dataset.addressResults
                ? JSON.parse(CheckoutStepTwoDOM.dataset.addressResults)
                : null
            const component = createApp(CheckoutStepTwo, {
                addressResults
            }).use(Store)
            component.mount(CheckoutStepTwoDOM)
        })
    }
}
